/* eslint-disable react/react-in-jsx-scope */
import { FC } from 'react';

import moment from 'moment';
import { convertUtcToDate } from '../common/helper';

function hasTimezone(dateString: string) {
  return dateString?.toString()?.includes('Z');
}

interface Props {
  value: moment.Moment | Date | string;
  format: string;
  convertToUTC?: boolean;
  offset?: number;
}

const DateField: FC<Props> = ({
  value,
  format,
  convertToUTC = false,
  offset,
}) => {
  let result = null;
  let _convertToUTC = convertToUTC;

  if (!convertToUTC && hasTimezone(value as string)) {
    _convertToUTC = true;
  }

  if (moment(value).isValid()) {
    result = convertUtcToDate(value, format, offset, _convertToUTC);
  } else {
    result = convertUtcToDate(
      `1970-01-01 ${value}`,
      format,
      offset,
      _convertToUTC,
    );
  }

  return <>{result}</>;
};

export { DateField };
